"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ItauCheckNumberCalculator = /** @class */ (function () {
    function ItauCheckNumberCalculator() {
    }
    ItauCheckNumberCalculator.calculate = function (agencyNumber, accountNumber) {
        var numbers = (agencyNumber + accountNumber).split("");
        var sumSeq = 0;
        var sequence = 0;
        for (var i = 0; i < numbers.length; i++) {
            var n = parseInt(numbers[i]);
            sequence = this.multiplyAccordingParity(n, i);
            sequence = this.adjustAccordingLength(sequence);
            sumSeq += sequence;
        }
        return this.module(sumSeq);
    };
    ItauCheckNumberCalculator.multiplyAccordingParity = function (n, index) {
        return n * (index % 2 === 0 ? 2 : 1);
    };
    ItauCheckNumberCalculator.adjustAccordingLength = function (sequence) {
        if (sequence > 9) {
            var numbers = sequence.toString().split("");
            sequence = 0;
            for (var _i = 0, numbers_1 = numbers; _i < numbers_1.length; _i++) {
                var n = numbers_1[_i];
                sequence += parseInt(n);
            }
        }
        return sequence;
    };
    ItauCheckNumberCalculator.module = function (sumSeq) {
        var module = sumSeq % 10;
        if (module === 0)
            return "0";
        else
            return (10 - module).toString();
    };
    return ItauCheckNumberCalculator;
}());
exports.default = ItauCheckNumberCalculator;
//# sourceMappingURL=ItauCheckNumberCalculator.js.map